import { HugeiconsIcon } from "@hugeicons/react";
import { CallOutgoing02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { PlayIcon } from "@hugeicons-pro/core-solid-rounded";
import { PreviewFrame } from "./PreviewFrame";
import { GhostMessageCard } from "./CommunicationPreview";

// One period of the recording waveform (Figma 394:7658 "Player"): bar heights in
// px, drawn 1.22px wide with a 2.14px gap and repeated until the row is full.
const WAVEFORM_PERIOD = [
  27.24, 10.71, 17.14, 10.71, 10.71, 17.14, 17.14, 10.71, 10.71, 27.24, 11.32,
  17.14, 10.71, 10.71, 17.14, 10.71, 27.24, 17.14, 17.14, 10.71, 10.71
];
const WAVEFORM_BARS = 96;

/**
 * Teaser for the locked Call channel in the inbox composer (Figma BoomCRM-Paywall
 * 393:4883 / 394:7658): a call-log card with a recording player on the Pro
 * gradient frame, a blurred message card behind it. Compact-only — it has no
 * full-page paywall.
 */
export const CallPreview = () => (
  <PreviewFrame compact badge="pro">
    <GhostMessageCard />
    <div
      className="absolute flex h-[177px] w-[358px] flex-col gap-4 overflow-hidden rounded-lg border border-alpha-100 bg-white px-5 pb-4 pt-5"
      style={{ left: "18px", top: "46.5px" }}
    >
      <div className="flex items-center gap-2">
        <span
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-alpha-40 text-content-300"
          aria-hidden="true"
        >
          <HugeiconsIcon icon={CallOutgoing02Icon} size={20} />
        </span>
        <div className="flex flex-col gap-1">
          <p className="text-base font-medium leading-6 text-content-1000">
            Incoming call
          </p>
          <p className="text-[13px] font-medium leading-4 text-content-300">
            Duration: 2:34
          </p>
        </div>
      </div>
      <div className="flex w-full flex-col gap-2">
        <p className="text-base font-medium leading-6 text-content-200">
          Recording
        </p>
        <div className="flex w-full items-center gap-3">
          <span
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white"
            aria-hidden="true"
          >
            <HugeiconsIcon icon={PlayIcon} size={20} />
          </span>
          <div
            className="flex min-w-0 flex-1 items-center gap-[2.14px] overflow-hidden"
            aria-hidden="true"
          >
            {Array.from({ length: WAVEFORM_BARS }, (_, index) => (
              <span
                key={index}
                className="w-[1.22px] shrink-0 rounded-full bg-alpha-100"
                style={{
                  height: `${WAVEFORM_PERIOD[index % WAVEFORM_PERIOD.length]}px`
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </PreviewFrame>
);
